const messages = {
  dashboard: {
    title: "Tableau de bord des commerciaux",
    description:
      "Bienvenue sur votre tableau de bord. Ici, vous pouvez consulter les indicateurs clés actuels ainsi que les entreprises participantes parmi vos clients.",
    overview: {
      title: "Aperçu des clients participants",
      description:
        "Entreprises inscrites à BRIDGESTONE PLUS et que nous avons pu associer à vous via leur numéro client.",
      month: "Nouveaux ce mois-ci",
      year: "Nouveaux cette année",
      all: "Tous",
    },
    credits: {
      title: "Crédits de points",
      description:
        "Points de récompense attribués aux entreprises participantes en fonction des volumes de ventes transmis.",
      month: "Mois en cours",
      year: "Année en cours",
      prev_year: "Total points",
      allDealers: "Tous les points des revendeurs",
      allPoints: "Tous les points",
      prev_month: "Mois précédent",
    },
    details: {
      title: "Détail des clients participants",
      description:
        "Vous trouverez ci-dessous la liste des entreprises qui se sont inscrites à BRIDGESTONE <span class=\"text-danger\">PLUS</span> avec un numéro client Bridgestone et qui vous sont attribuées en tant que responsable. Utilisez les fonctions de tri ou la barre de recherche pour modifier l'ordre d'affichage. Remarque : en cliquant sur le solde des points, vous accéderez au relevé de compte détaillé.",
    },
    lastImport:
      'Dernier import des chiffres de ventes : <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Les entreprises participantes reçoivent des crédits sous forme de remises basées sur les chiffres de ventes transmis.",
    },
    tyres: {
      title: "Pneus",
      description: "Pneus achetés par les participants au programme de bonus",
    },
    short:
      "Bienvenue sur votre tableau de bord. Vous y trouverez les chiffres actuels et les entreprises participantes de votre clientèle.",
    headers: {
      city: "Ville",
      company: "Société",
      current_points: "Points à date",
      customer_number: " N° de compte",
      details: "Détails",
      last_login: "Dernière connexion",
      name: "Nom de famille",
      postal_code: "Code Postal",
      street: "Rue",
      email: "Adresse email",
    },
    reload: "Recharger",
    exports: {
      title: "Fichiers Excel exportés",
      downloadExcel: "Télécharger Excel",
      running: "En cours",
      head: {
        name: "Nom",
        status: "Statut",
      },
    },
  },
};
export default {
  messages,
};
